import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import WhyChoose from "@/components/site/WhyChoose";
import Process from "@/components/site/Process";
import Industries from "@/components/site/Industries";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

export default function Landing() {
  return (
    <main className="relative bg-white">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <WhyChoose />
      <Process />
      <Industries />
      <About />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
